import script from "./VerificationBadgeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationBadgeComponent.vue?vue&type=script&setup=true&lang=js"

import "./VerificationBadgeComponent.vue?vue&type=style&index=0&id=73370cd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73370cd4"]])

export default __exports__